export const sendTrackingEvent = (eventObj: { [key: string]: string }) => {
	if (window && window.dataLayer && window.dataLayer.push) {
		window.dataLayer.push({ ...eventObj });
	}
};
